var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.userId)?_c('div',{staticClass:"profile"},[_c('span',{staticClass:"dropdown__btn-label"},[_vm._v(_vm._s(_vm.userId))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }